import { render, staticRenderFns } from "./AllCourses.vue?vue&type=template&id=abe0e406&"
import script from "./AllCourses.vue?vue&type=script&lang=js&"
export * from "./AllCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports